import React, { useEffect, useState } from "react";
import { MetadataElement, MetadataElementList, TableData } from "./SingleUploadModel";
import "./SingleUploadContent.scss";
import AssetMetaDataContainer from "./AssetMetaDataContainer";
import { useSelector } from "react-redux";
import Loading from "components/Placeholders/Loading";
import ProductValidation from "./ProductValidation";

interface SingleUploadContentProps {
  assetTypeKey: string;
}

const SingleUploadContent: React.FC<SingleUploadContentProps> = ({ assetTypeKey }) => {
  const [tableData, setTableData] = useState<TableData[]>([]);
  const assetTypes = useSelector(
    (state: any) => state.assetTypeReducer?.assetTypes
  );
  const loading = useSelector((state: any) => state.loading.isLoading);
  
  const selectedAssetType = assetTypeKey;

  const getDefaults = (metadataCollection: any) => {
    const defaults = metadataCollection?.DEFAULTS || {};
    let assetTypeDefaults = defaults?.[selectedAssetType] || {};
    return assetTypeDefaults;
  };

  // Function to generate tableData in the required format
  const generateTableData = () => {
    const metadataElementList =
    assetTypes?.metadata_collection?.[selectedAssetType]?.metadata_collection?.metadata_element_list;

    if (!metadataElementList) {
      return;
    }

    const groupedData = metadataElementList.reduce((acc: TableData[], category: MetadataElementList) => {
      const groupedByMetaTableId = category.metadata_element_list.reduce((group: any, element: MetadataElement) => {
        if (element.is_tabular === "Y" && element.meta_table_id) {
          if (!group[element.meta_table_id]) {
            group[element.meta_table_id] = [];
          }
          group[element.meta_table_id].push(element);
        }
        return group;
      }, {});

      Object.keys(groupedByMetaTableId).forEach((metaTableId) => {
        acc.push({
          name: category.id,
          meta_table_id: metaTableId,
          elements: groupedByMetaTableId[metaTableId],
        });
      });

      return acc;
    }, []);
    setTableData(groupedData);
  };

  const shouldShowElement = (element: MetadataElement): boolean => {
    if (element.is_displayable !== "Y"){
      return false;
    } 
    if (element.is_editable === "Y"){
      return true;
    } 
    const defaults = getDefaults(assetTypes?.metadata_collection);
    return element.is_editable === "N" && !!defaults?.[element.field_id];
  };


  // Generate tableData on component mount
  useEffect(() => {
    generateTableData();
  }, []);

  return (
    <div className="single-upload-content-wrapper">
      {assetTypes?.metadata_collection?.[selectedAssetType]?.metadata_collection?.metadata_element_list?.map(
        (assetMetadata: any) =>
          assetMetadata.metadata_element_list.some((element: any) => shouldShowElement(element)) && (
            <AssetMetaDataContainer shouldShowElement={shouldShowElement} key={assetMetadata.id} assetMetadata={assetMetadata} tableData={tableData} />
          )
      )}
      {loading && <Loading />}
      <ProductValidation/>
    </div>
  );
};

export default SingleUploadContent;